import { TabsStateTypes } from '@kubit/web-ui-components/tabs/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { arrowIconContainerCommonStyles, commonIconStyles } from '../commonStyles';
import { TabsVariantType } from '../variants';
export const getPrimaryTabsStyles = (FOUNDATIONS, FONT) => {
    return {
        [TabsVariantType.PRIMARY_TABS]: {
            oneTabContainer: {
                display: 'flex',
                justify_content: 'center',
                cursor: 'default',
                width: '100%',
                padding_bottom: FOUNDATIONS.spacing_200,
                padding_top: FOUNDATIONS.spacing_200,
            },
            arrowLeftIconContainer: {
                ...arrowIconContainerCommonStyles(FOUNDATIONS),
                padding_left: FOUNDATIONS.spacing_100,
            },
            leftIcon: {
                ...commonIconStyles(FOUNDATIONS),
                disabled: {
                    ...commonIconStyles(FOUNDATIONS),
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
            rightIcon: {
                ...commonIconStyles(FOUNDATIONS),
                disabled: {
                    ...commonIconStyles(FOUNDATIONS),
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
            arrowRightIconContainer: {
                ...arrowIconContainerCommonStyles(FOUNDATIONS),
                right: FOUNDATIONS.spacing_100,
            },
            [TabsStateTypes.SELECTED]: {
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    font_weight: FONT_WEIGHT.font_bold,
                    color: FOUNDATIONS.color_comp_navigation_primarytabs_font,
                },
                tabButton: {
                    width: '100%',
                    padding_bottom: FOUNDATIONS.spacing_200,
                    padding_top: FOUNDATIONS.spacing_200,
                    padding_left: FOUNDATIONS.spacing_00,
                    padding_right: FOUNDATIONS.spacing_00,
                    background_color: FOUNDATIONS.color_comp_navigation_primarytabs_unselected_bg,
                    border_bottom_color: FOUNDATIONS.color_comp_navigation_primarytabs_selected_border,
                    border_bottom_style: 'solid',
                    border_bottom_width: FOUNDATIONS.border_150,
                    cursor: 'default',
                    [DeviceBreakpointsType.MOBILE]: {
                        padding_bottom: FOUNDATIONS.spacing_200,
                        padding_top: FOUNDATIONS.spacing_200,
                        padding_left: FOUNDATIONS.spacing_00,
                        padding_right: FOUNDATIONS.spacing_00,
                    },
                },
            },
            [TabsStateTypes.UNSELECTED]: {
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_comp_navigation_primarytabs_font,
                },
                tabButton: {
                    width: '100%',
                    padding_bottom: FOUNDATIONS.spacing_200,
                    padding_top: FOUNDATIONS.spacing_200,
                    padding_left: FOUNDATIONS.spacing_00,
                    padding_right: FOUNDATIONS.spacing_00,
                    background_color: FOUNDATIONS.color_comp_navigation_primarytabs_unselected_bg,
                    cursor: 'pointer',
                    [DeviceBreakpointsType.MOBILE]: {
                        padding_bottom: FOUNDATIONS.spacing_200,
                        padding_top: FOUNDATIONS.spacing_200,
                        padding_left: FOUNDATIONS.spacing_00,
                        padding_right: FOUNDATIONS.spacing_00,
                    },
                },
            },
            [TabsStateTypes.HOVER]: {
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_comp_navigation_primarytabs_font,
                },
                tabButton: {
                    width: '100%',
                    padding_bottom: FOUNDATIONS.spacing_200,
                    padding_top: FOUNDATIONS.spacing_200,
                    padding_left: FOUNDATIONS.spacing_00,
                    padding_right: FOUNDATIONS.spacing_00,
                    background_color: FOUNDATIONS.color_comp_navigation_primarytabs_hover_bg,
                    cursor: 'pointer',
                    [DeviceBreakpointsType.MOBILE]: {
                        padding_bottom: FOUNDATIONS.spacing_200,
                        padding_top: FOUNDATIONS.spacing_200,
                        padding_left: FOUNDATIONS.spacing_00,
                        padding_right: FOUNDATIONS.spacing_00,
                    },
                },
            },
            [TabsStateTypes.PRESSED]: {
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_comp_navigation_primarytabs_font,
                },
                tabButton: {
                    width: '100%',
                    padding_bottom: FOUNDATIONS.spacing_200,
                    padding_top: FOUNDATIONS.spacing_200,
                    padding_left: FOUNDATIONS.spacing_00,
                    padding_right: FOUNDATIONS.spacing_00,
                    background_color: FOUNDATIONS.color_comp_navigation_primarytabs_hover_bg,
                    cursor: 'pointer',
                    [DeviceBreakpointsType.MOBILE]: {
                        padding_bottom: FOUNDATIONS.spacing_200,
                        padding_top: FOUNDATIONS.spacing_200,
                        padding_left: FOUNDATIONS.spacing_00,
                        padding_right: FOUNDATIONS.spacing_00,
                    },
                },
            },
            [TabsStateTypes.DISABLED]: {
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                tabButton: {
                    width: '100%',
                    padding_bottom: FOUNDATIONS.spacing_200,
                    padding_top: FOUNDATIONS.spacing_200,
                    padding_left: FOUNDATIONS.spacing_00,
                    padding_right: FOUNDATIONS.spacing_00,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                    cursor: 'pointer',
                    [DeviceBreakpointsType.MOBILE]: {
                        padding_bottom: FOUNDATIONS.spacing_200,
                        padding_top: FOUNDATIONS.spacing_200,
                        padding_left: FOUNDATIONS.spacing_00,
                        padding_right: FOUNDATIONS.spacing_00,
                    },
                },
            },
            [TabsStateTypes.EMPTY]: {
                tabButton: {
                    padding: FOUNDATIONS.spacing_00,
                    min_height: '3rem',
                },
            },
        },
    };
};
//# sourceMappingURL=primaryTabs.js.map